import React, { useState, useRef, useEffect, useMemo } from "react";
import {Typography} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { isMobile } from 'react-device-detect';
import ClientGraphContainer from '../components/client_version/ClientGraphContainer';
import UtilityGraphContainer from "../UtilityGraphContainer";
import { electricUnitTypes,  gasUnitTypes, waterUnitTypes  } from "../../../../../example_data/dropdowns/clientModal/loggingComponents";

const AirCard = props => {

  const insightTime = useMemo(() => {
    switch (props.plotSpecs.timeframe) {
        case '7d':
            return 'this past week';
        case '14d':
            return 'the past 2 weeks';
        case '31d':
            return 'this past month';
        case '365d':
            return 'this past year';
        case '24h':
            return 'this past day';
        default:
            return '';
    }
}, [props.plotSpecs.timeframe]);

   const determineUnits = isTotal => {
        if(isTotal){
            if(props.plotSpecs.activeUtility === 'water'){
                return props.plotSpecs.metricType.startsWith('L') ? 'L' : 'm³'

            }else if(props.plotSpecs.activeUtility === 'electricity'){
                return props.plotSpecs.metricType === 'Current (A)' ? 'A' : props.plotSpecs.metricType;

            }else if(props.plotSpecs.activeUtility === 'gas'){
                return 'm³';
            }
        }
        return props.plotSpecs.metricType === 'Current (A)' ? 'A' : props.plotSpecs.metricType;
    }

    const getInsightName = comp => {
        let totalCheck = comp.split('-');

        if(totalCheck.length === 2 && totalCheck[0] === 'total'){
            let unitLookup = props.plotSpecs.activeUtility === 'gas' ? gasUnitTypes : props.plotSpecs.activeUtility === 'water' ? waterUnitTypes : electricUnitTypes;
            
            if(unitLookup.some(u => u.value === totalCheck[1])){
                return unitLookup.find(u => u.value === totalCheck[1])?.text ?? totalCheck[1];
            }
        }

        return comp;
    }


    const fmt = n => Number(Math.round((n + Number.EPSILON) * 100) / 100).toLocaleString();

    return (
        <>
          <h4>Insights for {insightTime}</h4>

          {
            (props.data == null ? true : props.data.length === 0) ?
            <Box sx={{ display: 'flex' }}>
              <CircularProgress style={{margin:'auto'}}/>
            </Box>
            :
            <>
              {props.airMetrics && (
                <div style={{marginBottom: '1rem'}}>
                  <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'0.5rem 1rem', marginBottom:'0.5rem'}}>
                    <div>
                      <Typography variant="caption" color="text.secondary">Loaded</Typography>
                      <Typography variant="body2"><strong>{fmt(props.airMetrics.loadedkW)} kW</strong></Typography>
                    </div>
                    <div>
                      <Typography variant="caption" color="text.secondary">Unloaded</Typography>
                      <Typography variant="body2"><strong>{fmt(props.airMetrics.unloadedkW)} kW</strong></Typography>
                    </div>
                    <div>
                      <Typography variant="caption" color="text.secondary">VFD Energy</Typography>
                      <Typography variant="body2"><strong>{fmt(props.airMetrics.vfdkWh)} kWh</strong></Typography>
                    </div>
                    <div>
                      <Typography variant="caption" color="text.secondary">Leak Loss</Typography>
                      <Typography variant="body2"><strong>{fmt(props.airMetrics.leakskW)} kW</strong></Typography>
                    </div>
                  </div>
                  <div style={{padding:'0.4rem 0.6rem', backgroundColor:'rgba(211,47,47,0.08)', borderLeft:'3px solid #d32f2f', borderRadius:'2px'}}>
                    <Typography variant="caption" color="text.secondary">Air Leak</Typography>
                    <Typography variant="body2">
                      <strong>{fmt(props.airMetrics.leakPercent)}%</strong> &nbsp;·&nbsp; {fmt(props.airMetrics.leakscfm)} CFM &nbsp;·&nbsp; {fmt(props.airMetrics.leakskW)} kW
                    </Typography>
                  </div>
                </div>
              )}
              {
                props.insights == null ? (
                  <p>Highlight a range of the graph to see a summary of the timeseries data.</p>
                ) : props.insights === 'error' ? (
                  <p>Error processing insights.</p>
                ) : typeof props.insights === 'object' ? (
                  Object.keys(props.insights)
                  .sort((a, b) => a.localeCompare(b))
                  .map((comp) => (
                    <div key={comp}>
                      <strong>{getInsightName(comp)}</strong>
                      <p className="m-0">
                        Min: {Number(Math.round((props.insights[comp].min + Number.EPSILON) * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {determineUnits(false)}
                      </p>
                      <p className="m-0">
                        Max: {Number(Math.round((props.insights[comp].max + Number.EPSILON) * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {determineUnits(false)}
                      </p>
                    </div>
                  ))
                ) : null
              }
            </>
          }
        </>
    );
};

export default AirCard;